import { useState } from "react";
import { parsePastedDate } from "../../helpers/shipping";
import { DatePickerInput } from "../DatePickerInput";

export const BoxDate = ({
    box, 
    date,
    access,
    formattedDate,
    setEditedBoxes, 
    testId, 
    editedBoxes,
    keyDate,
    additionalWrapperClassname,
    additionalHoverClassname
}) => {

    const [isHovered, setIsHovered] = useState(false);
    const minDateBound = "2018-01-01";
    const maxDateBound = `${new Date().getFullYear() + 5}-12-31`;

    const shouldShowFormatted =
      !isHovered && !editedBoxes[box.id]?.[keyDate] && box[keyDate];

    return (
        <div
            className={`relative w-36 ${additionalWrapperClassname || ""}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {shouldShowFormatted && (
                <div className={`absolute top-1/2 w-24 py-0.5 px-2 transform -translate-y-1/2 left-1 bg-white text-base ${additionalHoverClassname || ""}`}>
                    {formattedDate}
                </div>
            )}
            <DatePickerInput
                value={date}
                min={minDateBound}
                max={maxDateBound}
                onPaste={(e) => {
                    if (access === "edit") {
                        const pastedText = e.clipboardData.getData('text');
                        const parsed = parsePastedDate(pastedText);
                        if (parsed) {
                            e.preventDefault();
                            setEditedBoxes({
                                ...editedBoxes,
                                [box.id]: {
                                    ...(editedBoxes[box.id] || box),
                                    [keyDate]: parsed,
                                },
                            });
                        }
                    }
                }}
                onChange={(value) => {
                    if (access === "edit") {
                        setEditedBoxes({
                            ...editedBoxes,
                            [box.id]: {
                                ...(editedBoxes[box.id] || box),
                                [keyDate]: value,
                            },
                        });
                    }
                }}
                testId={testId || null}
                disabled={access !== "edit"}
                className="w-full"
                buttonClassName="!h-[30px] !px-2 !py-0.5 !text-base disabled:!bg-gray-200"
            />
        </div>
    );
}